import styled from "styled-components";

export const Step1PhoneRegisFormStyled = styled.div`
  margin: auto;
  width: 100%;
  .register_header {
    margin-bottom: 12px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .register_title {
    margin-bottom: 14px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.GRAY_12};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .register_phone {
    margin-bottom: 67px;
  }

  .register_button {
    margin-bottom: 20px;
  }
  .back {
    display: flex;
    justify-content: center;
    align-items: baseline;
    .back_text {
      color: ${({ theme }) => theme.COLORS.GRAY_14};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
    .back_button {
      background: none;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }
`;
